import dayjs from 'dayjs';
import { getIsoDateFormat, shortDateFormat } from '@/core/utils/date';
import { getNestedObjectProperty } from '@/core/utils/object';
import { isValidEmail } from '@/core/utils/string';
import { isNumber, isObject } from '@/core/utils/type-guards';
import { numberFromString } from './number';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const required = (errorMessage?: string) => (value: unknown) =>
  (!Array.isArray(value) && (value === 0 || !!value)) ||
  (Array.isArray(value) && !!value.length) ||
  errorMessage ||
  'Обязательное поле';

export const isDefined = (errorMessage?: string) => (value: unknown) =>
  (!Array.isArray(value) && (value === 0 || (value !== undefined && value !== null))) ||
  (Array.isArray(value) && !!value.length) ||
  errorMessage ||
  'Обязательное поле';

export const minLength = (minLength: number, errorMessage?: string) => (value: string | number | null | undefined) =>
  !value || String(value).length >= minLength || errorMessage || `Мин. длина ${minLength} символов`;

export const maxLength = (maxLength: number, errorMessage?: string) => (value: string | number | null | undefined) =>
  !value || String(value).length <= maxLength || errorMessage || `Макс. длина ${maxLength} символов`;

export const min = (minValue: number, errorMessage?: string) => (value: string | number | null | undefined) =>
  (!value && value !== 0) ||
  (!numberFromString(`${value}`) && `${value}`.trim() !== '0') ||
  numberFromString(`${value}`)! >= minValue ||
  errorMessage ||
  `Мин. значение — ${minValue}`;

export const max = (maxValue: number, errorMessage?: string) => (value: string | number | null | undefined) =>
  (!value && value !== 0) ||
  (!numberFromString(`${value}`) && `${value}`.trim() !== '0') ||
  numberFromString(`${value}`)! <= maxValue ||
  errorMessage ||
  `Макс. значение — ${maxValue}`;

export const length =
  (length: number, errorMessage?: string, key?: string) =>
  (value: string | number | null | undefined | unknown | Record<string, unknown>) => {
    if (key && isObject(value) && getNestedObjectProperty(value, key)) {
      value = getNestedObjectProperty(value, key);
    }
    return !value || String(value).length === length || errorMessage || `Значение должно иметь ${length} символов`;
  };

export const phoneRule =
  (length: number = 11, errorMessage?: string) =>
  (value: string | number | null | undefined) =>
    !value ||
    (value && String(value).replace(/\D+/g, '').length >= length) ||
    errorMessage ||
    `Телефон должен содержать не менее ${length} цифр`;

export const emailRule = (errorMessage?: string) => (value: string | number | null | undefined) =>
  !value || (value && isValidEmail(String(value))) || errorMessage || 'Неверный формат e-mail';

export const URLRule = (errorMessage?: string) => (value: string | number | null | undefined) =>
  !value ||
  (value &&
    /(?:https?):\/\/([a-zA-Zа-яА-Я0-9]([a-zA-Zа-яА-Я0-9-]{0,61}[a-zA-Zа-яА-Я0-9])?\.)+[a-zA-Zа-яА-Я]{2,6}/gi.test(
      String(value),
    )) ||
  errorMessage ||
  'Неверный формат URL';

export const dateLessOrEqual =
  (value2: string | Date | null | undefined, errorMessage?: string) => (value1: string | number | null | undefined) =>
    !value1 ||
    !value2 ||
    isNumber(value1) ||
    (value1 && value2 && !dayjs(getIsoDateFormat(value1, shortDateFormat)).isAfter(value2)) ||
    errorMessage ||
    'Не может быть больше даты по';

export const dateMoreOrEqual =
  (value2: string | Date | null | undefined, errorMessage?: string) => (value1: string | number | null | undefined) =>
    !value1 ||
    !value2 ||
    isNumber(value1) ||
    (value1 && value2 && !dayjs(getIsoDateFormat(value1, shortDateFormat)).isBefore(value2)) ||
    errorMessage ||
    'Не может быть меньше даты с';

export const timeRule = (errorMessage?: string) => (value: string | number | null | undefined) => {
  const hours = String(value).substring(0, 2);
  const minutes = String(value).substring(3, 5);

  return (
    !value ||
    (hours.length === 2 && +hours <= 24 && minutes.length === 2 && +minutes <= 60) ||
    errorMessage ||
    'Неверный формат'
  );
};
